import getTimesheet from "./getTimesheet";
import getUser from "./getUser";
import listTimeSheets from "./listTimesheets";
import listLocations from "./listLocations";
import timeSheetByUserId from "./timesheetByUserId";
import fetchDailyReports from "./fetchDailyReports";
import fetchDailyReport from "./fetchDailyReport";
import notificationsByUserId from "./notificationsByUserId";
import dailyReportByUserId from "./dailyReportByUserId";
import deleteTimesheet from "./deleteTimesheet";
import deleteTimeEntry from "./deleteTimeEntry";
import deleteDailyReport from "./deleteDailyReport";
import deleteNotification from "./deleteNotification";
import deleteUser from "./deleteUser";
import createDailyReport from "./createDailyReport";
import createTimesheet from "./createTimesheet";
import createUser from "./createUser";
import createNotification from "./createNotification";
import updateUser from "./updateUser";
import updateLocation from "./updateLocation";
import updateTimesheet from "./updateTimesheet";
import createTimeEntry from "./createTimeEntry";
import updateTimeEntry from "./updateTimeEntry";
import updateDailyReport from "./updateDailyReport";
import updateNotification from "./updateNotification";

export default {
    fetchDailyReports,
    fetchDailyReport,
    getTimesheet,
    getUser,
    listTimeSheets,
    listLocations,
    timeSheetByUserId,
    notificationsByUserId,
    dailyReportByUserId,
    deleteTimesheet,
    deleteTimeEntry,
    deleteDailyReport,
    deleteNotification,
    deleteUser,
    createDailyReport,
    createTimesheet,
    createUser,
    createNotification,
    updateUser,
    updateLocation,
    updateTimesheet,
    createTimeEntry,
    updateTimeEntry,
    updateDailyReport,
    updateNotification,
};
